// extracted by mini-css-extract-plugin
export default {"add_tag_container":"AddCaseTagPopup_add_tag_container__G5kV+","autocomplete_container":"AddCaseTagPopup_autocomplete_container__+zFvr"};